module.exports = __webpack_public_path__ + "img/2.da9b5123.png";